// src/pages/ForgotPassPage.js
// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { MdEmail } from 'react-icons/md';
import { forgotPassword } from '../api/axios';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';

const Form = styled.form`
  max-width: 400px;
  margin: 20px auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const IconWrapper = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
`;

const Input = styled.input`
  padding: 10px 10px 10px 40px; /* Platz für das Icon */
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
`;

const Button = styled.button`
  padding: 10px;
  font-size: 1rem;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 auto;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const Message = styled.p`
  text-align: center;
  color: ${props => (props.error ? 'red' : 'green')};
`;

const InfoText = styled.p`
  text-align: center;
  font-size: 0.9rem;
`;

const ForgotPassPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(false);
  const [feedback, setFeedback] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFeedback('');
    try {
      const response = await forgotPassword(email);
      setFeedback(response.success || t('forgotPassPage.successMessage'));
      // Starte einen 10-Sekunden-Cooldown: Button deaktivieren und Input leeren nach 10 Sekunden
      setCooldown(true);
      setTimeout(() => {
        setCooldown(false);
        setEmail('');
      }, 10000);
    } catch (error) {
      setFeedback(error.error || t('forgotPassPage.errorMessage'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title={t('forgotPassPage.title')} />
      <InfoText>
        {t('forgotPassPage.infoText')}
      </InfoText>
      <Form onSubmit={handleSubmit}>
        <InputWrapper>
          <IconWrapper>
            <MdEmail />
          </IconWrapper>
          <Input
            type="email"
            placeholder={t('forgotPassPage.emailPlaceholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </InputWrapper>
        <Button type="submit" disabled={loading || cooldown}>
          {loading ? t('forgotPassPage.sending') : t('forgotPassPage.resetPassword')}
        </Button>
      </Form>
      {feedback && <Message error={feedback.toLowerCase().includes("error")}>{feedback}</Message>}
    </PageContentComponent>
  );
};

export default ForgotPassPage;
